import { makeStyles } from "@material-ui/core";
const styles = makeStyles({
    header: {padding:'1rem', backgroundColor: '#08090A', fontSize: '1.125rem', fontWeight: '400', color: '#FFFFFF' },
    title: { color: '#1E2831', fontSize: '1.25rem', fontWeight: '500' },
    subtitle: { color: '#1E283170', fontSize: '1rem', fontWeight: '400' },
    content: { backgroundColor: '#FFFFFF' },
    listItem: {},
})
export default styles;